export enum PermissionEnum {
    EditJob = 'EditJob',
    EditPumpSchedule = 'EditPumpSchedule',
    EditLOFASchedule = 'EditLOFASchedule',
    ViewJobPlan = 'ViewJobPlan',
    EditJobPlan = 'EditJobPlan',
    ViewLoads = 'ViewLoads',
    AddLoads = 'AddLoads',
    ManageLoads = 'ManageLoads',
    EditLoadDetails = 'EditLoadDetails',
    ViewDriverLoads = 'ViewDriverLoads',
    ViewDriverCompany = 'ViewDriverCompany',
    EditDriverCompany = 'EditDriverCompany',
    EditLogisticsPartner = 'EditLogisticsPartner',
    ViewDriver = 'ViewDriver',
    EditDriver = 'EditDriver',
    ViewDriverWellAssignment = 'ViewDriverWellAssignment',
    EditDriverWellAssignment = 'EditDriverWellAssignment',
    ViewSettings = 'ViewSettings',
    EditSettings = 'EditSettings',
    EditCustomer = 'EditCustomer',
    ViewCrew = 'ViewCrew',
    EditCrew = 'EditCrew',
    ViewProppant = 'ViewProppant',
    EditProppant = 'EditProppant',
    DeleteProppant = 'DeleteProppant',
    ViewLOFA = 'ViewLOFA',
    EditLOFA = 'EditLofa',
    ViewUsers = 'ViewUsers',
    EditUsers = 'EditUsers',
    EditPermissions = 'EditPermissions',
    LoadReport = 'LoadReport',
    DriverScheduleReport = 'DriverScheduleReport',
    ViewMessages = 'ViewMessages',
    SendMessages = 'SendMessages',
    ViewLogs = 'ViewLogs',
    UserRolesReport = 'UserRolesReport',
    RolesPermissionsReport = 'RolesPermissionsReport',
    ViewAudits = 'ViewAudits',
    EditCustomerParent = 'EditCustomerParent',
    ViewJob = 'ViewJob',
    ViewCustomer = 'ViewCustomer',
    ViewCustomerParent = 'ViewCustomerParent',
    ViewPermissions = 'ViewPermissions',
    SplitLoads = 'SplitLoads',
    UploadImages = 'UploadImages',
    DriverSchedule = 'DriverSchedule',
    Edit3rdPartyCarrier = 'Edit3rdPartyCarrier',
    EditKronosID = 'EditKronosID',
    EditDriverRegion = 'EditDriverRegion',
    EditDriverDistrict = 'EditDriverDistrict',
    EditDriverCellNumber = 'EditDriverCell#',
    ViewJobsForLoading = 'ViewJobsForLoading',
    EditCompletedLoads = 'EditCompletedLoads',
    DeleteJob = 'DeleteJob',
    RunScripts = 'RunScripts',
    // TODO: Verify that these two permissions should be in QA and PROD - (9/26/19) BS
    UnlockDrivers = 'Unlockdrivers',
    ResetUserPasswords = 'Resetuserpasswords',
    // TODO: Verify that these permissions exist on backend - GB
    AddJobNotes = 'AddJobNotes',
    EditJobNotes = 'EditJobNotes',
    ViewJobNotes = 'ViewJobNotes',
    AddLoadNotes = 'AddLoadNotes',
    EditLoadNotes = 'EditLoadNotes',
    ViewLoadNotes = 'ViewLoadNotes',
    DeletePumpSchedule = 'DeletePumpSchedule',
    DeleteLOFASchedule = 'DeleteLOFASchedule',
    EditLoadProgress = 'EditLoadProgress',
    MarkLoadComplete = 'MarkLoadComplete',
    EditLoadTimestamps = 'EditLoadTimestamps',
    DeleteLoad = 'DeleteLoad',
    ViewStageSummary = 'ViewStageSummary',
    AddStages = 'AddStages',
    EditStages = 'EditStages',
    StartEndStage = 'StartEndStage',
    PauseResumeStage = 'PauseResumeStage',
    ViewStageSheet = 'ViewStageSheet',
    ViewStageHistory = 'ViewStageHistory',
    RevertStageSheet = 'RevertStageSheet',
    RevertStages = 'RevertStages',
    ConfigureRecipients = 'ConfigureRecipients',
    UpdateRunOrder = 'UpdateRunOrder',
    SendEmail = 'SendEmail',
    PrintForkliftOp = 'PrintForkliftOp',
    PrintAll = 'PrintAll',
    EditStageSheet = 'EditStageSheet',
    AddBoxes = 'AddBoxes',
    Download = 'Download',
    UpdateBoxes = 'UpdateBoxes',
    AddDriverLoadNotes = 'AddDriverLoadNotes',
    EditDriverLoadNotes = 'EditDriverLoadNotes',
    DeleteDriverLoadNotes = 'DeleteDriverLoadNotes',
    ViewDriverLoadNotes = 'ViewDriverLoadNotes',
    SandAllocationAssignDriver = 'SandAllocationAssignDriver',
    SandAllocationSetTonnage = 'SandAllocationSetTonnage',
    CurrentActivityAssignDriver = 'CurrentActivityAssignDriver',
    ViewOnsiteInventory = 'ViewOnsiteInventory',
    SetupLayout = 'SetupLayout',
    PrintExport = 'PrintExport',
    MoveBoxes = 'MoveBoxes',
    EditOnsiteInventory = 'EditOnsiteInventory',
    UpdateLoadFieldOp = 'UpdateLoadFieldOp',
    AddJobLogs = 'AddJobLogs',
    ViewJobLogs = 'ViewJobLogs',
    EditJobLogs = 'EditJobLogs',
    DeleteJobLogs = 'DeleteJobLogs',
    EditResolvedJobLogs = 'EditJobLogsExceptions',
    ViewYard = 'ViewYard',
    EditYard = 'EditYard',
    DeleteYard = 'DeleteYard',
    ViewDriverPool = 'ViewDriverPool',
    EditDriverPool = 'EditDriverPool',
    AddAssetLoads = 'AddAssetLoads',
    ViewAssetLoads = 'ViewAssetLoads',
    AddEditAssetLoadNotes = 'AddEditAssetLoadNotes',
    ViewAssetLoadNotes = 'ViewAssetLoadNotes',
    EditAssetLoadDetails = 'EditAssetLoadDetails',
    DeleteAssetLoad = 'DeleteAssetLoad',
    AdminEquipmentUI = 'AdminEquipmentUI',
    ViewEquipmentPlan = 'ViewEquipmentPlan',
    EditEquipmentPlan = 'EditEquipmentPlan',
    EditAssets = 'EditAssets',
    EditAssetLoadTimestamps = 'EditAssetLoadTimestamps',
    AssignAssetLoads = 'AssignAssetLoads',
    ViewAssetLoadHistory = 'ViewAssetLoadHistory',
    ViewBillingVOS = 'ViewBillingVOS',
    ViewVOS = 'ViewVOS',
    UploadVOS = 'UploadVOS',
    EditBellyDumpJob ='EditBellyDumpJob',
    AllocateAllLoads = 'AllocateAllLoads',
}


